import { render, staticRenderFns } from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=template&id=4b3ab63b&scoped=true&"
import script from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=script&lang=js&"
export * from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=script&lang=js&"
import style0 from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=style&index=0&id=4b3ab63b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ab63b",
  null
  
)

export default component.exports